import _ from 'underscore';
import $ from 'jquery';
import {
  RECOMMENDATION_PAGE_SIZES,
  RECOMMENDATION_TYPES,
  getImageExtensionPageSize,
} from '@bingads-webui-campaign/recommendation-core';
import { crossPageSelectHeadRow } from '@bingads-webui/projection-grid-cross-page-select-all';

import {
  INLINE_ACTION_MAP,
  isSelectableType,
  SUPPORT_APPLY_TYPES,
  SUPPORT_DOWNLOAD_TYPES,
  SUPPORT_DISMISS_TYPES,
  SUPPORT_RESUBMIT_TYPES,
  SUPPORT_DATE_FILTER_TYPES,
} from './const';
import { getColumnsByType, getDefaultSortColumn } from './columns/index';
import { RecommendationGridService } from './grid-service';

export function getPluginsConfig({
  deps,
  i18n,
  gridService,
  recommendationType,
  campaignType,
  el,
  downloadService,
  logOpportunityEvent,
  perfMarker,
  onEvent,
  isMCC,
  router,
  context,
  guid,
  view,
  readOnly,
  compact,
  channel,
  viewDetails,
  recommendationTypesAvailable,
  newI18n,
  serverContext,
  getGoalCreationRecommendationWizard,
  s$i18n,
  viewUET,
}) {
  const dismissBtnId = 'button-dismiss';
  const applyBtnId = 'button-apply';
  const toolbarItemWithSelectionIds = [];
  const toolbarMoreButton = {
    type: 'button',
    id: 'button-more',
    text: i18n.getString('Recommendation_More'),
    classes: ['btn', 'btn-secondary'],
    iconLeft: ['glyphicon', 'glyph-left'],
    onClick: () => {
      onEvent('back');
    },
  };
  const toolbarItems = [];

  if (!compact) {
    toolbarItems.push(toolbarMoreButton);
  }

  if (_.contains(SUPPORT_APPLY_TYPES, recommendationType)) {
    toolbarItems.push({
      type: 'button',
      id: applyBtnId,
      text: i18n.getString('Button_Apply'),
      classes: ['btn', 'btn-primary'],
      disabled: readOnly,
    });
    if (!readOnly) {
      toolbarItemWithSelectionIds.push(applyBtnId);
    }
  }

  if (_.contains(SUPPORT_RESUBMIT_TYPES, recommendationType)) {
    toolbarItems.push({
      type: 'button',
      id: applyBtnId,
      text: i18n.getString('Button_Resubmit'),
      classes: ['btn', 'btn-primary'],
      disabled: readOnly,
    });
    if (!readOnly) {
      toolbarItemWithSelectionIds.push(applyBtnId);
    }
  }

  if (_.contains(SUPPORT_DISMISS_TYPES, recommendationType)) {
    toolbarItems.push({
      type: 'button',
      id: dismissBtnId,
      text: i18n.getString('Button_Dismiss'),
      classes: ['btn', 'btn-secondary'],
      disabled: readOnly,
    });

    if (!readOnly) {
      toolbarItemWithSelectionIds.push(dismissBtnId);
    }
  }

  if (_.contains(SUPPORT_DATE_FILTER_TYPES, recommendationType)) {
    toolbarItems.push({
      type: 'dropdown',
      button: {
        text: i18n.getString('Dropdown_Button_LastSixMonth'),
      },
      id: 'dropdown-date-filter',
      menu: {
        items: [{
          text: i18n.getString('Dropdown_Menu_LastThreeMonth'),
          id: 'dropdown-item-lastthreemonth',
        },
        {
          text: i18n.getString('Dropdown_Menu_LastSixMonth'),
          id: 'dropdown-item-lastsixmonth',
        }],
      },
    });
  }

  if (_.contains(SUPPORT_DOWNLOAD_TYPES, recommendationType)) {
    toolbarItems.push({
      type: 'button',
      id: 'button-download',
      iconLeft: ['glyphicon', 'icon-export-normal'],
      text: i18n.getString('Details_View_Download_All'),
    });
  }

  const imageExtensionPageSize = getImageExtensionPageSize(deps.permissions);

  const availablePageSizes = recommendationType === RECOMMENDATION_TYPES.IMAGE_EXTENSION ?
    imageExtensionPageSize : RECOMMENDATION_PAGE_SIZES.slice();

  // need test the cross page select all in selenium test
  if (window.location.href.indexOf('EnableOnePageSizeOption') > -1) {
    availablePageSizes.unshift(1);
  }

  return {
    toolbar: {
      toolbar: {
        items: toolbarItems,
      },
    },
    recommendationInlineAction: {
      deps,
      i18n,
      newI18n,
      actionType: INLINE_ACTION_MAP[recommendationType],
      gridService,
      logOpportunityEvent,
      router,
      isMCC,
      readOnly,
      el,
      perfMarker,
      serverContext,
      getGoalCreationRecommendationWizard,
      s$i18n,
      viewUET,
    },
    recommendationToolBarPlugin: {
      deps,
      i18n,
      gridService,
      recommendationType,
      campaignType,
      downloadService,
      logOpportunityEvent,
      context,
      guid,
      view,
      el,
      readOnly,
      onEvent,
      isMCC,
      channel,
      compact,
      viewDetails,
      recommendationTypesAvailable,
      newI18n,
    },
    dismissFeedback: {
      buttonId: dismissBtnId,
    },
    projectionGridEnableWithSelection: {
      toolbarItemIds: toolbarItemWithSelectionIds,
    },
    crossPageSelectAll: {
      i18n,
    },
    pagination: {
      availablePageSizes,
      enableRandomPage: false,
      pageNumberLabelText: i18n.getString('Grid_Page_Number_Label_Text'),
      pageSizeText: i18n.getString('Grid_ShowRows'),
      totalPageCountText: i18n.getString('Grid_PageOf'),
      resetPageNumberOnSort: true,
    },
    uiBlocker: {
      el,
    },
    perfMarker: {
      marker: perfMarker,
      appConfig: deps.appConfig,
    },
    editable: {
      i18n,
    },
  };
}

export function getConfig({
  i18n,
  newI18n,
  s$i18n,
  deps,
  recommendationService,
  channel,
  recommendationType,
  campaignType,
  el,
  downloadService,
  view,
  onEvent,
  logOpportunityEvent,
  perfMarker,
  context,
  guid,
  primaryEstimate,
  isMCC,
  router,
  readOnly,
  compact,
  isOptimizationScoreOn = false,
  viewDetails,
  recommendationTypesAvailable,
  scope,
  filterState,
  data,
  serverContext,
  setData,
  setDataFromDetails,
  getGoalCreationRecommendationWizard,
  viewUET,
}) {
  const gridService = new RecommendationGridService(
    recommendationService,
    channel,
    recommendationType,
    campaignType,
    view,
    onEvent,
    logOpportunityEvent,
    context,
    guid,
    isMCC,
    setData,
    setDataFromDetails,
    deps.permissions.IsRecommendationCacheDetailPageDataEnabled
  );

  let headRows = [
    crossPageSelectHeadRow(),
    'column-header-rows',
  ];

  headRows = ['column-header-rows'];

  const scrolling = {
    header: {
      type: 'sticky',
      offset: () => $('.sticky-container').height(),
    },
    viewport: $('.recommendation-grid-page'),
    virtualized: false,
  };

  return {
    name: 'RecommendationGrid',
    tableClasses: ['table', 'table-bordered'],
    selection: {
      enabled: isSelectableType(recommendationType, isMCC),
      headClasses: ['text-center'],
      bodyClasses: ['text-center'],
    },
    columns: getColumnsByType({
      recommendationType,
      i18n,
      newI18n,
      s$i18n,
      deps,
      view,
      isMCC,
      readOnly,
      scope,
      filterState,
      data,
      isOptimizationScoreOn,
    }),
    plugins: getPluginsConfig({
      i18n,
      newI18n,
      s$i18n,
      deps,
      gridService,
      recommendationType,
      campaignType,
      el,
      downloadService,
      logOpportunityEvent,
      perfMarker,
      onEvent,
      isMCC,
      router,
      context,
      guid,
      view,
      readOnly,
      compact,
      channel,
      viewDetails,
      recommendationTypesAvailable,
      serverContext,
      getGoalCreationRecommendationWizard,
      viewUET,
    }),
    rows: {
      headRows,
    },
    dataSource: {
      type: 'js-data',
      entity: gridService,
    },
    scrolling,
    sortableHeader: isOptimizationScoreOn
      ? {}
      : getDefaultSortColumn(recommendationType, i18n, primaryEstimate),
  };
}
